export default __webpack_public_path__ + "static/mobile-application-enhancing-sports-betting-experience-ea8409bbb6878d984673d57ba760c8aa.png";